export default __webpack_public_path__ + "static/media/ellipse.361c311a.png";